/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import { useContext, useEffect } from 'react';
import axios from 'axios';
import { MyContext } from '../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';

const KhaltiPayment = ({ Amount }) => {

    const { paymentBaseURL, setPaymentLoading } = useContext(MyContext);

    const handlePayment = async () => {
        
        secureLocalStorage.setItem("Amount", Amount);

        await axios.post(`${paymentBaseURL}react_khalti/index.php`,
            {
                "amt": Amount
            }
        )
            .then((res) => {
                if (res.data.Result === "true") {
                    window.location.href = res.data.payment_url;
                    setPaymentLoading(false);
                }
            })
            .catch((error) => {
                console.error("react_khalti/index.php", error);
            });
    };

    useEffect(() => {
        if (!Amount) return;
        handlePayment();
    }, [Amount]);

    return null;
};

export default KhaltiPayment;
/* jshint ignore:end */